import styled from 'styled-components';
import colors from '../../theme/colors';

const { GREY } = colors;

const TooltipItem = styled.li`
  height: 26px;
  font-size: 12px;
  color: ${GREY};
  list-style: none;
  a,
  button {
    padding: 6px 0px 5px 8px;
    display: block;
    color: ${GREY};
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  :hover {
    background-color: #f6f7f9;
  }
`;

export default TooltipItem;



// WEBPACK FOOTER //
// ./components/atoms/TooltipItem.js